var _clipPath, _g, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagCh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#de2910"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25,18 27.9,26.9 37.4,26.9 29.7,32.5 32.6,41.4 25,35.8 17.4,41.4 20.3,32.5 12.6,26.9 22.1,26.9",
    fill: "#ffde00"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42,12 43.2,15.6 47,15.6 43.9,17.9 45.1,21.5 42,19.2 38.9,21.5 40.1,17.9 37,15.6 40.8,15.6",
    fill: "#ffde00"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48,22 49.2,25.6 53,25.6 49.9,27.9 51.1,31.5 48,29.2 44.9,31.5 46.1,27.9 43,25.6 46.8,25.6",
    fill: "#ffde00"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48,34 49.2,37.6 53,37.6 49.9,39.9 51.1,43.5 48,41.2 44.9,43.5 46.1,39.9 43,37.6 46.8,37.6",
    fill: "#ffde00"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42,44 43.2,47.6 47,47.6 43.9,49.9 45.1,53.5 42,51.2 38.9,53.5 40.1,49.9 37,47.6 40.8,47.6",
    fill: "#ffde00"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 48,
    fill: "none",
    stroke: "#ddd",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagCh);
export default __webpack_public_path__ + "static/media/flag-ch.01b117ff8e8031c61bc288e0d0fb7822.svg";
export { ForwardRef as ReactComponent };